import { Component, OnDestroy, OnInit } from '@angular/core';
import { DynamicBrandingService } from '@boxx/dynamic-branding';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-header-icon',
  templateUrl: './main-header-icon.component.html',
  styleUrls: ['./main-header-icon.component.scss'],
})
export class MainHeaderIconComponent implements OnInit, OnDestroy {
  brandLogo = '';
  brandName = '';

  private destroyed$ = new Subject();

  constructor(dBrandingService: DynamicBrandingService) {
    this.brandLogo = dBrandingService.logo ? dBrandingService.logo : './assets/icon/Icon_Header_Brand.svg';
    dBrandingService.appCopies$.pipe(takeUntil(this.destroyed$)).subscribe(hasChanges => {
      if (hasChanges) {
        this.brandName = dBrandingService.tradename.toUpperCase();
        if(dBrandingService.tradename.toUpperCase() === 'BOXX' || dBrandingService.tradename.toUpperCase() === 'BOXX CRM' || dBrandingService.tradename.toUpperCase() === '#BOXX'){
          this.brandLogo = './assets/icon/Icon_Header_Brand.svg';
        }
        else if(dBrandingService.tradename.toUpperCase() === 'ENDIGITAL'){
          this.brandLogo = './assets/img/ed_white.png';
        }
        else{
          this.brandLogo = dBrandingService.logo;
        }        
      }
    });
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
